import { Pipe, PipeTransform } from "@angular/core";
import { OrderStatus } from "@gloria-public/order/domain/interfaces/order.interface";
import { ServiceRequestPaymentStatus } from "../interfaces/cart.interface";

@Pipe({
  name: "orderStatus",
})
export class OrderStatusPipe implements PipeTransform {
  transform(status: OrderStatus): string {
    switch (status) {
      case OrderStatus.PENDING_CHECKOUT:
        return "page.order.ordersHistory.orderStatus.pending";
      case OrderStatus.PAYMENT_FAILED:
        return "page.order.ordersHistory.orderStatus.paymentFailed";
      case OrderStatus.PAID:
        return "page.order.ordersHistory.orderStatus.paid";
      default:
        return "";
    }
  }
}

@Pipe({ name: "srPaymentStatusIcon" })
export class SRPaymentStatusIconPipe implements PipeTransform {
  transform(status: ServiceRequestPaymentStatus): string {
    switch (status) {
      case ServiceRequestPaymentStatus.CANCELED:
      case ServiceRequestPaymentStatus.EXPIRED:
        return "event_busy";
      case ServiceRequestPaymentStatus.NOT_PAID:
        return "block";
      case ServiceRequestPaymentStatus.PAST_DUE:
        return "error_outline";
      case ServiceRequestPaymentStatus.PENDING:
        return "hourglass_empty";
      default:
        return "";
    }
  }
}

@Pipe({ name: "srPaymentStatusColor" })
export class SRPaymentStatusColorPipe implements PipeTransform {
  transform(status: ServiceRequestPaymentStatus): string {
    switch (status) {
      case ServiceRequestPaymentStatus.PENDING:
      case ServiceRequestPaymentStatus.CANCELED:
      case ServiceRequestPaymentStatus.EXPIRED:
        return "#ffc107";
      case ServiceRequestPaymentStatus.PAST_DUE:
      case ServiceRequestPaymentStatus.NOT_PAID:
        return "#dc3545";
      default:
        return "#6c757d";
    }
  }
}

@Pipe({ name: "srPaymentStatus" })
export class SRPaymentStatusPipe implements PipeTransform {
  transform(status: ServiceRequestPaymentStatus): string {
    switch (status) {
      case ServiceRequestPaymentStatus.PENDING:
        return "page.order.ordersHistory.paymentStatus.pending";
      case ServiceRequestPaymentStatus.PAST_DUE:
        return "page.order.ordersHistory.paymentStatus.past_due";
      case ServiceRequestPaymentStatus.NOT_PAID:
        return "page.order.ordersHistory.paymentStatus.not_paid";
      case ServiceRequestPaymentStatus.EXPIRED:
        return "page.order.ordersHistory.paymentStatus.expired";
      case ServiceRequestPaymentStatus.CANCELED:
        return "page.order.ordersHistory.paymentStatus.canceled";
      default:
        return "";
    }
  }
}
